var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickupTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_15339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 22.875H1.56252C0.68748 22.875 0 22.125 0 21.25V5.56246C0 4.68748 0.68748 4 1.56252 4H16.5625C17.4375 4 18.125 4.68748 18.125 5.56252V22.875H18.125Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 12.75L25.5625 8.75002C25.3125 8.5 24.9375 8.3125 24.5625 8.3125H18.125V22.875H28.375C29.25 22.875 30 22.125 30 21.2501V13.7501C30 13.3125 29.875 13.0001 29.5625 12.75Z",
    fill: "#F3705A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.125V21.25C0 22.1249 0.68748 22.8125 1.56252 22.8125H28.375C29.25 22.8125 30 22.0625 30 21.1875V20.0625H0V20.125Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.875 15.9375V14L24.3125 10.375H20.25V15.9375H27.875Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62498 26C9.76507 26 11.5 24.2651 11.5 22.125C11.5 19.9849 9.76507 18.25 7.62498 18.25C5.48489 18.25 3.75 19.9849 3.75 22.125C3.75 24.2651 5.48489 26 7.62498 26Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 24C8.66053 24 9.5 23.1605 9.5 22.125C9.5 21.0895 8.66053 20.25 7.625 20.25C6.58947 20.25 5.75 21.0895 5.75 22.125C5.75 23.1605 6.58947 24 7.625 24Z",
    fill: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.375 26C25.5151 26 27.25 24.2651 27.25 22.125C27.25 19.9849 25.5151 18.25 23.375 18.25C21.2349 18.25 19.5 19.9849 19.5 22.125C19.5 24.2651 21.2349 26 23.375 26Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.375 24C24.4105 24 25.25 23.1605 25.25 22.125C25.25 21.0895 24.4105 20.25 23.375 20.25C22.3395 20.25 21.5 21.0895 21.5 22.125C21.5 23.1605 22.3395 24 23.375 24Z",
    fill: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93752 6.625C3.18752 6.625 2.5625 7.25002 2.5625 8.00002V16.0625C2.5625 16.8125 3.18752 17.4375 3.93752 17.4375C4.68752 17.4375 5.31254 16.8125 5.31254 16.0625V8.00002C5.25002 7.24996 4.68752 6.625 3.93752 6.625Z",
    fill: "#F7B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 6.625C8.25002 6.625 7.625 7.25002 7.625 8.00002V16.0625C7.625 16.8125 8.25002 17.4375 9.00002 17.4375C9.75002 17.4375 10.375 16.8125 10.375 16.0625V8.00002C10.3125 7.24996 9.75002 6.625 9.00002 6.625Z",
    fill: "#F7B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.625C13.3125 6.625 12.6875 7.25002 12.6875 8.00002V16.0625C12.6875 16.8125 13.3125 17.4375 14.0625 17.4375C14.8125 17.4375 15.4375 16.8125 15.4375 16.0625V8.00002C15.375 7.24996 14.8125 6.625 14.0625 6.625Z",
    fill: "#F7B64C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_15339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupTruck);
export default __webpack_public_path__ + "static/media/pickup-truck.21cccd7a37059d71e5ccbcaf6583a8c8.svg";
export { ForwardRef as ReactComponent };